import { render, staticRenderFns } from "./text255.vue?vue&type=template&id=7835fc53"
import script from "./text255.vue?vue&type=script&lang=js"
export * from "./text255.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports